import React from 'react';
import { Download } from 'lucide-react';
import { trackEvent, EVENTS } from '../../lib/analyticsV2';
import { ownerVerifiedContent } from './contentConfig';

const LeadMagnetV2 = () => {
  const handleDownload = () => {
    trackEvent('lead_magnet_submit', { asset_id: 'checklist_patrimonial' });
    // In a real scenario, this could open a modal for an email or directly download if free
  };

  return (
    <section className="py-16 md:py-24 bg-primary text-primary-foreground">
      <div className="container px-4 md:px-6 mx-auto max-w-4xl">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-3xl font-bold tracking-tight md:text-4xl mb-4">
              Checklist para avaliar uma estratégia patrimonial de longo prazo
            </h2>
            <p className="text-primary-foreground/80 text-lg mb-6 leading-relaxed">
              Um material educativo para organizar objetivo, prazo, liquidez, custos, regras de contemplação e riscos antes de comparar alternativas. Não é recomendação individual nem promessa de resultado.
            </p>
            
            <button 
              onClick={handleDownload}
              className="inline-flex h-12 items-center justify-center rounded-md bg-background text-foreground px-8 text-base font-semibold shadow transition-colors hover:bg-background/90"
            >
              <Download className="mr-2 h-5 w-5" />
              Receber o checklist
            </button>
            <p className="text-xs text-primary-foreground/60 mt-4">
              O download é opcional e não exige o envio de dados obrigatórios de contato. Veja nossa <a href={ownerVerifiedContent.privacyPolicyUrl} className="underline">política de privacidade</a>.
            </p>
          </div>
          
          <div className="relative mx-auto w-full max-w-sm rounded-xl border border-primary-foreground/20 bg-background/5 p-2 shadow-2xl backdrop-blur-sm">
            <div className="aspect-[3/4] rounded-lg bg-card/10 flex items-center justify-center p-8 text-center border border-dashed border-primary-foreground/30">
              <div>
                <div className="w-16 h-16 rounded-full bg-background/20 flex items-center justify-center mx-auto mb-4">
                  <Download className="h-8 w-8 text-primary-foreground" />
                </div>
                <h3 className="text-xl font-bold mb-2">O Código da Decisão</h3>
                <p className="text-sm text-primary-foreground/70">Guia de perguntas que você precisa fazer antes de assinar um contrato longo.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnetV2;
